import { paddingLarge } from "src/styles/spacing";

export const EditAddonHorizontalPadding = paddingLarge;
